import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import AdminApp from './AdminApp';
import { bootstrapNativeShell } from './nativeBootstrap';

bootstrapNativeShell();

const root = ReactDOM.createRoot(document.getElementById('root'));

// Single, clean signal when React is ready
const signalReactReady = () => {
  console.log('React app ready, signaling to hide loader');
  window.dispatchEvent(new Event('react-ready'));
};

// Check if we're on an admin route once at startup
const isAdminRoute = window.location.pathname.startsWith('/admin');

console.log('Current path:', window.location.pathname);
console.log('Is admin route:', isAdminRoute);

// Render the appropriate app based on the route
if (isAdminRoute) {
  console.log('Rendering Admin App');
  root.render(
    <React.StrictMode>
      <AdminApp />
    </React.StrictMode>
  );
} else {
  console.log('Rendering Client App');
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

// Wait for React to fully mount, then signal once - FASTER
setTimeout(signalReactReady, 100); 